import Model from '@/models/Model.js';

export default class VideoActivity extends Model {
    static entity = 'video_activities';

    static fields() {
        return {
            id: this.attr(null),
            content_template_id: this.attr(null),
            video_id: this.attr(null),
            content: this.attr(null),
            acknowledgment_message: this.attr(null),

            ...super.fields(),

            content_template: this.belongsTo('video_activity_templates', 'content_template_id'),
            video: this.belongsTo('videos', 'video_id'),
            activity: this.morphOne('activities', 'contentable_id', 'contentable_type_entity'),
        };
    }
}
